module.exports = __webpack_public_path__ + "img/pick-date.f5da8aa4.svg";